import { ResidencyJurisdictionWithNestedObjectsResponseAuditable } from '../../../../web-api-client';
import { ResidencyJurisdiction } from '../../models';
import { mapCountryFromResponse } from '../country/map-country-from-response';

export const mapResidencyJurisdictionFromResponse = (
  response: ResidencyJurisdictionWithNestedObjectsResponseAuditable
): ResidencyJurisdiction => ({
  residencyJurisdictionId: response.residencyJurisdictionId!,
  country: response.country
    ? mapCountryFromResponse(response.country)
    : undefined,
  region: response.country?.region?.name ?? '',
  isActive: response.isActive ?? false,
  modified: response.modified!,
  name: response.country ? mapCountryFromResponse(response.country).name : '',
});
